import { TestProjectBaseline, TestProjectBaselineImpact, TestProjectTopic } from '../types';
import { PackageListModel } from './PackageListModel';

export function calculateBaselineImpact(
    topics: TestProjectTopic[],
    baselines: TestProjectBaseline[],
    retainedTopicIds: string[],
    documents: PackageListModel[]
): TestProjectBaselineImpact {
    const retainedIds = new Set(retainedTopicIds);
    const documentNames = new Map(documents.map(document => [document.packageId, document.name]));
    const baselinesByTopic = new Map<string, TestProjectBaseline[]>();
    const impact: TestProjectBaselineImpact = { retained: [], removed: [] };

    for (const baseline of baselines) {
        const records = baselinesByTopic.get(baseline.topicId) || [];
        records.push(baseline);
        baselinesByTopic.set(baseline.topicId, records);
    }

    for (const topic of topics) {
        const records = baselinesByTopic.get(topic.topicId) || [];
        const documentIds = [...new Set(records.map(record => record.packageId))];
        const input = {
            topicId: topic.topicId,
            name: topic.name,
            baselineCount: records.length,
            documents: documentIds.map(packageId => ({
                packageId,
                name: documentNames.get(packageId) || packageId
            }))
        };

        if (retainedIds.has(topic.topicId)) {
            impact.retained.push(input);
        } else {
            impact.removed.push(input);
        }
    }

    return impact;
}
